// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"W_-z"};